import { DataTable } from '@tiendanube/components';
import Text from 'commons/components/LegacyText';
import useTranslationBilling from 'domains/Billing/useTranslationBilling';

const { Cell, Header } = DataTable;

function PagoNubeDataTableHeader(): JSX.Element {
  const t = useTranslationBilling();
  return (
    <Header>
      <Cell grow={4}>
        <Text>{t('invoiceHistory.month')}</Text>
      </Cell>
      <Cell grow={1}>
        <Text>{t('invoiceHistory.download')}</Text>
      </Cell>
    </Header>
  );
}

export default PagoNubeDataTableHeader;
